import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'react-jss';
import { createMemoStyles, safeRest, defaultFonts } from '@wds/utils';
import { IconX, IconInfo, IconWarning, IconCheck, IconLock } from '@wds/icons';
import { Slide } from '@wds/motion';

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles$1 = createMemoStyles(function (_ref) {
  var spacing = _ref.spacing,
      type = _ref.type;
  return {
    wrenchCloseButton: function wrenchCloseButton(_ref2) {
      var component = _ref2.component;
      var componentSpecificStyles = {
        badge: {
          position: 'relative',
          top: 'none',
          right: 'none',
          padding: 0,
          marginLeft: spacing[3]
        },
        banner: {
          position: 'absolute',
          top: spacing[2],
          right: spacing[2],
          padding: 0
        },
        default: {
          position: 'absolute',
          right: spacing[1],
          top: spacing[1],
          padding: spacing[2]
        }
      };
      return _objectSpread$1(_objectSpread$1({}, componentSpecificStyles[component || 'default']), {}, {
        fontSize: type.fontSize.body,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        borderRadius: '0',
        textDecoration: 'none',
        background: 'transparent',
        border: 'none',
        '&:hover': {
          transition: 'none',
          textDecoration: 'none'
        },
        '&:active': {
          transition: 'none',
          outline: 'none'
        }
      });
    }
  };
});
var useStyles$2 = useStyles$1;

var _excluded$4 = ["children", "component", "label", "onClick", "type", "variant"];

var CloseButton = function CloseButton(_ref) {
  _ref.children;
      var component = _ref.component,
      label = _ref.label,
      onClick = _ref.onClick;
      _ref.type;
      var variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, _excluded$4);

  var theme = useTheme();

  var _useStyles = useStyles$2({
    theme: theme,
    component: component
  }),
      wrenchCloseButton = _useStyles.wrenchCloseButton;

  return /*#__PURE__*/React.createElement("button", Object.assign({
    onClick: onClick,
    type: "button",
    className: wrenchCloseButton,
    "aria-label": label
  }, safeRest(rest)), /*#__PURE__*/React.createElement(IconX, {
    title: "close",
    color: variant
  }));
};

CloseButton.displayName = "CloseButton";
CloseButton.propTypes = {
  children: PropTypes.string,
  component: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.string,
  variant: PropTypes.oneOf(['dark', 'light'])
};
CloseButton.defaultProps = {
  children: 'CloseButton',
  component: undefined,
  type: undefined,
  variant: 'light'
};
var CloseButton$1 = CloseButton;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = createMemoStyles(function (theme) {
  var palette = theme.palette,
      radius = theme.radius,
      shadow = theme.shadow,
      type = theme.type,
      spacing = theme.spacing,
      iconSize = theme.iconSize,
      breakpoints = theme.breakpoints;
  var toast = {
    padding: spacing[5],
    bgColor: palette.background.dark,
    typeColor: palette.text.light,
    borderRadius: radius.small,
    width: 350,
    titleFontSize: type.fontSize.body,
    bodyTypeSize: type.fontSize.bodySm,
    linkColor: palette.link.contrast,
    boxShadow: shadow.none
  };
  return {
    wrenchToastContainer: function wrenchToastContainer(_ref) {
      var elevation = _ref.elevation;
      return _defineProperty({
        position: 'fixed',
        right: spacing[3],
        bottom: spacing[3],
        left: spacing[3],
        zIndex: elevation || theme.elevation.space
      }, "@media (min-width:".concat(breakpoints.sm, "px)"), {
        right: spacing[5],
        bottom: spacing[5],
        width: toast.width,
        left: 'auto'
      });
    },
    wrenchToast: function wrenchToast() {
      return _objectSpread(_objectSpread({}, defaultFonts(theme)), {}, {
        boxSizing: 'border-box',
        margin: 0,
        padding: toast.padding,
        backgroundColor: toast.bgColor,
        color: toast.typeColor,
        borderRadius: toast.borderRadius,
        boxShadow: toast.boxShadow
      });
    },
    wrenchToastIcon: function wrenchToastIcon() {
      return {
        fontSize: iconSize.md,
        marginRight: spacing[3],
        float: 'left',
        display: 'inline-flex'
      };
    },
    wrenchToastTitle: function wrenchToastTitle(color) {
      return {
        color: toast.typeColor,
        fontSize: toast.titleFontSize,
        marginLeft: color && spacing[6]
      };
    },
    wrenchToastBody: function wrenchToastBody(color) {
      return {
        color: toast.typeColor,
        fontSize: toast.bodyTypeSize,
        marginTop: spacing[4],
        marginLeft: color && spacing[6],
        '& > a': {
          color: toast.linkColor,
          textDecoration: 'underline'
        }
      };
    },
    wrenchToastFooter: function wrenchToastFooter(color) {
      return {
        marginTop: spacing[4],
        marginLeft: color && spacing[6],
        '& > *': {
          marginRight: spacing[3]
        }
      };
    }
  };
});

var _excluded$3 = ["children"];

var ToastTitle = function ToastTitle(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$3);

  var theme = useTheme();
  var classes = useStyles({
    theme: theme
  });
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: classes.wrenchToastTitle
  }, rest), children);
};

ToastTitle.displayName = "ToastTitle";
ToastTitle.propTypes = {
  children: PropTypes.node.isRequired
};

var _excluded$2 = ["children"];

var ToastBody = function ToastBody(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$2);

  var theme = useTheme();
  var classes = useStyles({
    theme: theme
  });
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: classes.wrenchToastBody
  }, rest), children);
};

ToastBody.displayName = "ToastBody";
ToastBody.propTypes = {
  children: PropTypes.node.isRequired
};

var _excluded$1 = ["children"];

var ToastFooter = function ToastFooter(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$1);

  var theme = useTheme();
  var classes = useStyles({
    theme: theme
  });
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: classes.wrenchToastFooter
  }, rest), children);
};

ToastFooter.displayName = "ToastFooter";
ToastFooter.propTypes = {
  children: PropTypes.node.isRequired
};

var _excluded = ["ariaLabel", "onClose", "autoClose", "children", "dismissible", "color", "show", "elevation"];
var TOAST_COLORS = ['success', 'info', 'upgrade', 'warning', 'error'];
var TIMEOUT_DELAY = 3000;

var Toast = function Toast(_ref) {
  var ariaLabel = _ref.ariaLabel,
      onClose = _ref.onClose,
      autoClose = _ref.autoClose,
      children = _ref.children,
      dismissible = _ref.dismissible,
      color = _ref.color,
      show = _ref.show,
      elevation = _ref.elevation,
      rest = _objectWithoutProperties(_ref, _excluded);

  var timeoutRef = useRef(null);

  var _useState = useState(show),
      _useState2 = _slicedToArray(_useState, 2),
      localShow = _useState2[0],
      setLocalShow = _useState2[1];

  var theme = useTheme();
  var classes = useStyles({
    color: color,
    elevation: elevation,
    theme: theme
  });
  var ToastIcon = {
    info: IconInfo,
    warning: IconWarning,
    error: IconWarning,
    success: IconCheck,
    upgrade: IconLock
  }[color];

  var handleClose = function handleClose() {
    clearInterval(timeoutRef.current);
    setLocalShow(false);

    if (onClose) {
      onClose();
    }
  };

  var handleMouseEnter = function handleMouseEnter() {
    if (autoClose) {
      clearInterval(timeoutRef.current);
    }
  };

  var handleMouseExit = function handleMouseExit() {
    if (autoClose) {
      timeoutRef.current = setTimeout(function () {
        return handleClose();
      }, TIMEOUT_DELAY);
    }
  };

  useEffect(function () {
    if (autoClose && show) {
      timeoutRef.current = setTimeout(function () {
        return handleClose();
      }, TIMEOUT_DELAY);
    } else {
      clearInterval(timeoutRef.current);
    }

    setLocalShow(show);
    return function () {
      clearTimeout(timeoutRef.current);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrenchToastContainer
  }, /*#__PURE__*/React.createElement(Slide, {
    in: localShow,
    distance: "far"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", Object.assign({
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseExit,
    className: classes.wrenchToast,
    role: "alert"
  }, safeRest(rest)), dismissible ? /*#__PURE__*/React.createElement(CloseButton$1, {
    onClick: handleClose,
    label: ariaLabel,
    variant: "light"
  }) : null, color ? /*#__PURE__*/React.createElement("div", {
    className: classes.wrenchToastIcon
  }, /*#__PURE__*/React.createElement(ToastIcon, {
    color: color,
    title: "".concat(color, " icon")
  })) : null, children))));
};

Toast.displayName = "Toast";
Toast.propTypes = {
  /**
   * If true, Toast will auto close after 3 seconds
   */
  autoClose: PropTypes.bool,

  /**
   * Toast is composed of 3 subcomponents:
   * Toast.Title,
   * Toast.Body,
   * Toast.Footer
   */
  children: PropTypes.node.isRequired,

  /**
   * If true, an dismissble X icon will appear on the top right
   */
  dismissible: PropTypes.bool,

  /**
   * onClose event handler
   * function(event: object) => void
   */
  onClose: PropTypes.func,

  /**
   * Color variants for Toast
   */
  color: PropTypes.oneOf(TOAST_COLORS),

  /**
   * Specify custom aria label
   */
  ariaLabel: PropTypes.string,

  /**
   * If true, Toast will be visible in view
   */
  show: PropTypes.bool,

  /**
   * If provided, overrides the z-index value of the component
   */
  elevation: PropTypes.number
};
Toast.defaultProps = {
  autoClose: true,
  dismissible: false,
  onClose: undefined,
  color: undefined,
  ariaLabel: 'Close Toast',
  show: true,
  elevation: undefined
};
Toast.Title = ToastTitle;
Toast.Body = ToastBody;
Toast.Footer = ToastFooter;

export { Toast };
